const MapControl = () => {
    return (
        <>
            <h3 className="text-center">MapControl</h3>
        </>
    )
}

export default MapControl;